import { createAppSlice } from '../../app/createAppSlice'

//The browserTabTitleSlice is used to store the display value for use in the browser tab in the user interface.
const initialState = { tabTitle: "Computable Publishing" };

const browserTabTitleSlice = createAppSlice({
    name: "browserTabTitle",
    initialState,
    reducers: create => ({
        changeBrowserTabTitle: create.reducer((state, action) => {
            state.tabTitle = action.payload
        }),
    }),
    selectors: {
        selectBrowserTabTitle: browserTabTitle => browserTabTitle.tabTitle
    },
})

export const { changeBrowserTabTitle } = browserTabTitleSlice.actions

export const { selectBrowserTabTitle } = browserTabTitleSlice.selectors

export default browserTabTitleSlice